import styled from 'astroturf/react';
import { Banner as BannerBase } from 'js/design_system/Banner';
import { useImageAttachment } from './useImageAttachment';
import { usePaperAttachment } from './usePaperAttachment';
import { Image, Paper } from '../types';
import _Banner from "useAttachment-Banner.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/attachments/useAttachment.tsx?styleId=Banner";
import _LoadingBanner from "useAttachment-LoadingBanner.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/attachments/useAttachment.tsx?styleId=LoadingBanner";


export enum AttachmentStatus {
  Empty = 'empty',
  Loading = 'loading',
  Ready = 'ready',
}

export const Banner = /*#__PURE__*/styled(BannerBase, null, {
  displayName: "Banner",
  styles: _Banner
});

export const LoadingBanner = /*#__PURE__*/styled(Banner, null, {
  displayName: "LoadingBanner",
  styles: _LoadingBanner
});

export function useAttachment(
  initialImage?: Image,
  initialPaper?: Paper,
  removable?: boolean,
) {
  const {
    image,
    status: imageStatus,
    content: imageContent,
    onAttach: onImageAttach,
  } = useImageAttachment(initialImage, removable);
  const {
    paper,
    status: paperStatus,
    content: paperContent,
    onAttach: onPaperAttach,
    onPaperLinksChange,
  } = usePaperAttachment(initialPaper, removable);

  let status = AttachmentStatus.Empty;
  if (imageStatus !== AttachmentStatus.Empty) {
    status = imageStatus;
  } else if (paperStatus !== AttachmentStatus.Empty) {
    status = paperStatus;
  }

  const content = imageContent || paperContent;
  return {
    image,
    paper,
    status,
    content,
    hasAttachment: !!content,
    onImageAttach,
    onPaperAttach,
    onPaperLinksChange,
  };
}
